import * as React from "react"
import { AccordionPanel } from "."

export function assertIsPanel(
    arg: React.ReactNode
): asserts arg is React.ReactElement<React.ComponentProps<typeof AccordionPanel>, typeof AccordionPanel> {
    if (typeof arg === "object" && arg !== null) return
    throw new Error("Expected AccordionPanel")
}
